import { FC } from 'react';
import { CheckIcon, NotAllowedIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { Spinner } from '@chakra-ui/react';
import { VirusStatus } from '../../graphql/generated';
import { StatusLabel } from './status-label';

type AVStatusProps = {
  status: VirusStatus;
};

export const AVStatus: FC<AVStatusProps> = ({ status }) => {
  switch (status) {
    case VirusStatus.QUARANTINED:
      return (
        <StatusLabel label="Quarantined" data-testid="quarantined-status">
          <WarningTwoIcon color="red.500" boxSize="4" />
        </StatusLabel>
      );

    case VirusStatus.SCANNING:
      return (
        <StatusLabel label="Scanning" data-testid="scanning-status">
          <Spinner color="blue.500" size="sm" />
        </StatusLabel>
      );

    case VirusStatus.CLEAN:
      return (
        <StatusLabel label="Clean" data-testid="clean-status">
          <CheckIcon color="green.500" />
        </StatusLabel>
      );

    case VirusStatus.UNSUPPORTED:
      return (
        <StatusLabel label="Skipped" data-testid="skipped-status">
          <NotAllowedIcon color="gray.500" />
        </StatusLabel>
      );

    default:
      return null;
  }
};
